<template>
  <span>
    <i class="mdi mdi-information-outline text-primary font-size-14" ref="info-icon"></i>
    <b-tooltip :target="() => $refs['info-icon']" triggers="hover">
     <slot/>
    </b-tooltip>
  </span>
</template>

<script>
export default {
  name: "Hint"
}
</script>

<style scoped>

</style>